import { buscarEspecialidadesProfissionais } from "./profissionaisEspecialidade";

export type GrupoProfissional<T> = {
  idProfissional: number;
  nome: string;
  items: T[];
};

export type GrupoEspecialidade<T> = {
  especialidade: string;
  profissionais: GrupoProfissional<T>[];
};

type ItemComProfissional = {
  profissional?: {
    idProfissional: number;
    nmProfissional: string;
  };
  dtConsulta: string;
  hrConsulta: string;
};

export const agruparPorEspecialidade = async <T extends ItemComProfissional>(
  items: T[],
  filtro?: (item: T) => boolean,
  token?: string | null,
): Promise<GrupoEspecialidade<T>[]> => {
  const itensFiltrados = filtro ? items.filter(filtro) : items;
  const gruposPorEspecialidade: Record<string, GrupoEspecialidade<T>> = {};
  const profissionaisIds: number[] = [];

  itensFiltrados.forEach((item) => {
    const idProfissional = item.profissional?.idProfissional;
    if (idProfissional && !profissionaisIds.includes(idProfissional)) {
      profissionaisIds.push(idProfissional);
    }
  });

  const especialidadesMap = await buscarEspecialidadesProfissionais(
    profissionaisIds,
    token,
  );

  itensFiltrados.forEach((item) => {
    const profissional = item.profissional;
    if (!profissional) return;

    const especialidade =
      especialidadesMap[profissional.idProfissional] || "Sem Especialidade";

    if (!gruposPorEspecialidade[especialidade]) {
      gruposPorEspecialidade[especialidade] = {
        especialidade,
        profissionais: [],
      };
    }

    const grupo = gruposPorEspecialidade[especialidade];
    let profissionalGrupo = grupo.profissionais.find(
      (p) => p.idProfissional === profissional.idProfissional,
    );

    if (!profissionalGrupo) {
      profissionalGrupo = {
        idProfissional: profissional.idProfissional,
        nome: profissional.nmProfissional,
        items: [],
      };
      grupo.profissionais.push(profissionalGrupo);
    }

    profissionalGrupo.items.push(item);
  });

  Object.values(gruposPorEspecialidade).forEach((grupo) => {
    grupo.profissionais.forEach((profissional) => {
      profissional.items.sort((a, b) => {
        const dateA = new Date(`${a.dtConsulta}T${a.hrConsulta}`);
        const dateB = new Date(`${b.dtConsulta}T${b.hrConsulta}`);
        return dateB.getTime() - dateA.getTime();
      });
    });
  });

  return Object.values(gruposPorEspecialidade);
};

